import _defineProperty from "/app/admin/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/admin/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/app/admin/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeDialog"],
    _excluded2 = ["forceMount"],
    _excluded3 = ["__scopeDialog"],
    _excluded4 = ["forceMount"],
    _excluded5 = ["__scopeDialog", "trapFocus", "onOpenAutoFocus", "onCloseAutoFocus"],
    _excluded6 = ["__scopeDialog"],
    _excluded7 = ["__scopeDialog"],
    _excluded8 = ["__scopeDialog"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Slot as e } from "@radix-ui/react-slot";
import { hideOthers as o } from "aria-hidden";
import { RemoveScroll as t } from "react-remove-scroll";
import { useFocusGuards as r } from "@radix-ui/react-focus-guards";
import { Primitive as n } from "@radix-ui/react-primitive";
import { Presence as a } from "@radix-ui/react-presence";
import { UnstablePortal as i } from "@radix-ui/react-portal";
import { FocusScope as l } from "@radix-ui/react-focus-scope";
import { DismissableLayer as c } from "@radix-ui/react-dismissable-layer";
import { useControllableState as s } from "@radix-ui/react-use-controllable-state";
import { useId as u } from "@radix-ui/react-id";
import { createContext as p, createContextScope as d } from "@radix-ui/react-context";
import { useComposedRefs as f } from "@radix-ui/react-compose-refs";
import { composeEventHandlers as g } from "@radix-ui/primitive";
import * as m from "react";
import D from "@babel/runtime/helpers/esm/extends";

var _d = d("Dialog"),
    _d2 = _slicedToArray(_d, 2),
    x = _d2[0],
    C = _d2[1];

export { C as createDialogScope };

var _x = x("Dialog"),
    _x2 = _slicedToArray(_x, 2),
    v = _x2[0],
    E = _x2[1];

export var Dialog = function Dialog(e) {
  var o = e.__scopeDialog,
      t = e.children,
      r = e.open,
      n = e.defaultOpen,
      a = e.onOpenChange,
      _e$modal = e.modal,
      i = _e$modal === void 0 ? !0 : _e$modal,
      l = e.allowPinchZoom,
      c = m.useRef(null),
      p = m.useRef(null),
      _s = s({
    prop: r,
    defaultProp: n,
    onChange: a
  }),
      _s2 = _slicedToArray(_s, 2),
      _s2$ = _s2[0],
      d = _s2$ === void 0 ? !1 : _s2$,
      f = _s2[1];
  /*#__PURE__*/


  return m.createElement(v, {
    scope: o,
    triggerRef: c,
    contentRef: p,
    contentId: u(),
    titleId: u(),
    descriptionId: u(),
    open: d,
    onOpenChange: f,
    onOpenToggle: m.useCallback(function () {
      return f(function (e) {
        return !e;
      });
    }, [f]),
    modal: i,
    allowPinchZoom: l
  }, t);
};
/*#__PURE__*/

export var DialogTrigger = /*#__PURE__*/m.forwardRef(function (e, o) {
  var t = e.__scopeDialog,
      r = _objectWithoutProperties(e, _excluded),
      a = E("DialogTrigger", t),
      i = f(o, a.triggerRef);
  /*#__PURE__*/


  return m.createElement(n.button, D({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": b(a.open)
  }, r, {
    ref: i,
    onClick: g(e.onClick, a.onOpenToggle)
  }));
});
/*#__PURE__*/

export var DialogPortal = function DialogPortal(e) {
  var o = e.__scopeDialog,
      t = e.forceMount,
      r = e.children,
      n = e.container,
      l = E("DialogPortal", o);
  /*#__PURE__*/

  return m.createElement(m.Fragment, null, m.Children.map(r, function (e) {
    return /*#__PURE__*/m.createElement(a, {
      present: t || l.open
    }, /*#__PURE__*/m.createElement(i, {
      asChild: !0,
      container: n
    }, e));
  }));
};
/*#__PURE__*/

export var DialogOverlay = /*#__PURE__*/m.forwardRef(function (e, o) {
  var t = e.forceMount,
      r = _objectWithoutProperties(e, _excluded2),
      n = E("DialogOverlay", e.__scopeDialog);

  return n.modal ? /*#__PURE__*/m.createElement(a, {
    present: t || n.open
  }, /*#__PURE__*/m.createElement(R, D({}, r, {
    ref: o
  }))) : null;
});
/*#__PURE__*/

var R = /*#__PURE__*/m.forwardRef(function (o, r) {
  var a = o.__scopeDialog,
      i = _objectWithoutProperties(o, _excluded3),
      l = E("DialogOverlay", a);
  /*#__PURE__*/


  return m.createElement(t, {
    as: e,
    allowPinchZoom: l.allowPinchZoom,
    shards: [l.contentRef]
  }, /*#__PURE__*/m.createElement(n.div, D({
    "data-state": b(l.open)
  }, i, {
    ref: r,
    style: _objectSpread({
      pointerEvents: "auto"
    }, i.style)
  })));
});
export var DialogContent = /*#__PURE__*/m.forwardRef(function (e, o) {
  var t = e.forceMount,
      r = _objectWithoutProperties(e, _excluded4),
      n = E("DialogContent", e.__scopeDialog);
  /*#__PURE__*/


  return m.createElement(a, {
    present: t || n.open
  }, n.modal ? /*#__PURE__*/m.createElement(_, D({}, r, {
    ref: o
  })) : /*#__PURE__*/m.createElement(O, D({}, r, {
    ref: o
  })));
});
/*#__PURE__*/

var _ = /*#__PURE__*/m.forwardRef(function (e, t) {
  var r = E("DialogContent", e.__scopeDialog),
      n = m.useRef(null),
      a = f(t, r.contentRef, n);
  return m.useEffect(function () {
    var e = n.current;
    if (e) return o(e);
  }, []), /*#__PURE__*/m.createElement(h, D({}, e, {
    ref: a,
    trapFocus: r.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: g(e.onCloseAutoFocus, function (e) {
      var o;
      e.preventDefault(), null === (o = r.triggerRef.current) || void 0 === o || o.focus();
    }),
    onPointerDownOutside: g(e.onPointerDownOutside, function (e) {
      var o = e.detail.originalEvent,
          t = 0 === o.button && !0 === o.ctrlKey;
      (2 === o.button || t) && e.preventDefault();
    }),
    onFocusOutside: g(e.onFocusOutside, function (e) {
      return e.preventDefault();
    })
  }));
}),
    O = /*#__PURE__*/m.forwardRef(function (e, o) {
  var t = E("DialogContent", e.__scopeDialog),
      r = m.useRef(!1);
  /*#__PURE__*/

  return m.createElement(h, D({}, e, {
    ref: o,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: function onCloseAutoFocus(o) {
      var n, a;
      (null === (n = e.onCloseAutoFocus) || void 0 === n || n.call(e, o), o.defaultPrevented) || (r.current || null === (a = t.triggerRef.current) || void 0 === a || a.focus(), o.preventDefault());
      r.current = !1;
    },
    onInteractOutside: function onInteractOutside(o) {
      var n, a;
      null === (n = e.onInteractOutside) || void 0 === n || n.call(e, o), o.defaultPrevented || (r.current = !0);
      var i = o.target;
      (null === (a = t.triggerRef.current) || void 0 === a ? void 0 : a.contains(i)) && o.preventDefault();
    }
  }));
}),
    h = /*#__PURE__*/m.forwardRef(function (e, o) {
  var t = e.__scopeDialog,
      n = e.trapFocus,
      a = e.onOpenAutoFocus,
      i = e.onCloseAutoFocus,
      s = _objectWithoutProperties(e, _excluded5),
      u = E("DialogContent", t),
      p = m.useRef(null),
      d = f(o, p);

  return r(), /*#__PURE__*/m.createElement(m.Fragment, null, /*#__PURE__*/m.createElement(l, {
    asChild: !0,
    loop: !0,
    trapped: n,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i
  }, /*#__PURE__*/m.createElement(c, D({
    role: "dialog",
    id: u.contentId,
    "aria-describedby": u.descriptionId,
    "aria-labelledby": u.titleId,
    "data-state": b(u.open)
  }, s, {
    ref: d,
    onDismiss: function onDismiss() {
      return u.onOpenChange(!1);
    }
  }))), !1);
});

export var DialogTitle = /*#__PURE__*/m.forwardRef(function (e, o) {
  var t = e.__scopeDialog,
      r = _objectWithoutProperties(e, _excluded6),
      a = E("DialogTitle", t);
  /*#__PURE__*/


  return m.createElement(n.h2, D({
    id: a.titleId
  }, r, {
    ref: o
  }));
});
/*#__PURE__*/

export var DialogDescription = /*#__PURE__*/m.forwardRef(function (e, o) {
  var t = e.__scopeDialog,
      r = _objectWithoutProperties(e, _excluded7),
      a = E("DialogDescription", t);
  /*#__PURE__*/


  return m.createElement(n.p, D({
    id: a.descriptionId
  }, r, {
    ref: o
  }));
});
/*#__PURE__*/

export var DialogClose = /*#__PURE__*/m.forwardRef(function (e, o) {
  var t = e.__scopeDialog,
      r = _objectWithoutProperties(e, _excluded8),
      a = E("DialogClose", t);
  /*#__PURE__*/


  return m.createElement(n.button, D({
    type: "button"
  }, r, {
    ref: o,
    onClick: g(e.onClick, function () {
      return a.onOpenChange(!1);
    })
  }));
});
/*#__PURE__*/

function b(e) {
  return e ? "open" : "closed";
}

var _p = p("DialogTitleWarning", {
  contentName: "DialogContent",
  titleName: "DialogTitle",
  docsSlug: "dialog"
}),
    _p2 = _slicedToArray(_p, 2),
    w = _p2[0],
    F = _p2[1];

export { w as WarningProvider };
export var Root = Dialog;
export var Trigger = DialogTrigger;
export var Portal = DialogPortal;
export var Overlay = DialogOverlay;
export var Content = DialogContent;
export var Title = DialogTitle;
export var Description = DialogDescription;
export var Close = DialogClose;